var _g, _g2, _g3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOffice(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#754400",
    height: "800px",
    width: "800px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    stroke: "#754400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M133.442,268.993H17.332V121.685c0-4.786-3.88-8.666-8.666-8.666S0,116.9,0,121.685v155.973 c0,4.786,3.88,8.666,8.666,8.666h2.6v103.99c0,4.786,3.88,8.666,8.666,8.666c4.786,0,8.666-3.88,8.666-8.666v-64.994h84.914 v64.994c0,4.786,3.88,8.666,8.666,8.666s8.666-3.88,8.666-8.666v-103.99h2.6c4.786,0,8.666-3.88,8.666-8.666 C142.108,272.873,138.228,268.993,133.442,268.993z M113.511,307.989H28.597v-21.665h84.914V307.989z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M503.334,113.02c-4.787,0-8.666,3.88-8.666,8.666v147.307H378.546c-4.787,0-8.666,3.88-8.666,8.666 c0,4.786,3.879,8.666,8.666,8.666h2.6v103.99c0,4.786,3.879,8.666,8.666,8.666c4.787,0,8.666-3.88,8.666-8.666v-64.994h84.925 v64.994c0,4.786,3.879,8.666,8.666,8.666s8.666-3.88,8.666-8.666v-103.99h2.6c4.787,0,8.666-3.88,8.666-8.666V121.685 C512,116.9,508.12,113.02,503.334,113.02z M483.403,307.989h-84.925v-21.665h84.925V307.989z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M404.652,186.382h-15.787h-94.152l-30.966-61.933c-1.469-2.936-4.469-4.79-7.751-4.79c-3.283,0-6.283,1.854-7.751,4.79 l-30.967,61.933h-94.152h-15.786c-4.786,0-8.666,3.88-8.666,8.666s3.88,8.666,8.666,8.666h7.12v25.996 c0,4.786,3.88,8.666,8.666,8.666H152.3v151.933c0,4.786,3.88,8.666,8.666,8.666c4.786,0,8.666-3.88,8.666-8.666V238.376h125.654 c4.787,0,8.666-3.88,8.666-8.666s-3.879-8.666-8.666-8.666H131.792v-17.33H380.2v17.33h-53.718c-4.787,0-8.666,3.88-8.666,8.666 s3.879,8.666,8.666,8.666h15.879v151.933c0,4.786,3.879,8.666,8.666,8.666c4.787,0,8.666-3.88,8.666-8.666V238.376h29.173 c4.787,0,8.666-3.88,8.666-8.666v-25.996h7.121c4.787,0,8.666-3.88,8.666-8.666S409.439,186.382,404.652,186.382z M236.656,186.383l19.34-38.681l19.341,38.681H236.656z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOffice);
export default __webpack_public_path__ + "static/media/office.faa0796aa4cb8f66f30860c1922910e8.svg";
export { ForwardRef as ReactComponent };